// Start of Event Service code
import { Observable, Subject } from 'rxjs';
import { Injectable } from '@angular/core';
import { filter, map, shareReplay } from 'rxjs/operators';

// Used to store key value pairs
interface Event {
    key: string;
    value: any;
}

@Injectable({
    providedIn: 'root',
})
export class EventService {
    protected eventsSubject = new Subject<Event>();

    constructor() {
    }

    /*Method is responsible for Broadcast Event */
    public broadcastEvent(key: string, value: any): void {
        this.eventsSubject.next({ key, value });
    }

    /* Method is responsible for Get Event*/
    public getEvent(key: string): Observable<any> {
        return this.eventsSubject.asObservable().pipe(
            filter(e => e.key === key),
            map(e => e.value),
            shareReplay(1)
        );
    }
}
